// The social-proof band's testimonial, localized to the policy's market
// — a Phoenix family reads a Phoenix neighbor, not a generic quote. One
// blurb per market: the rank-1 review from the pre-need review export
// (preneed-review-blurbs.csv, 2026-08-31). A market without a ranked
// review — or one we have not localized yet — falls back to the
// default, which is AZ1's rank-1 review by decision.

export interface MarketReview {
  reviewer: string;
  where: string;
  blurb: string;
}

const DEFAULT_REVIEW: MarketReview = {
  reviewer: "Kay B.",
  where: "Goodyear, AZ",
  blurb:
    "The process was easier than expected. We had put this off for way too long and it was taken care of in minutes.",
};

const MARKET_REVIEWS: Record<string, MarketReview> = {
  AZ1: {
    reviewer: "Kay B.",
    where: "Goodyear, AZ",
    blurb:
      "The process was easier than expected. We had put this off for way too long and it was taken care of in minutes.",
  },
  AZ2: {
    reviewer: "Myrna F.",
    where: "Tucson, AZ",
    blurb:
      "Pre-planning will ease the burden of grief off my loving family as they carry out my final wishes.",
  },
  CA1: {
    reviewer: "Joann T.",
    where: "Beaumont, CA",
    blurb:
      "I am so relieved to know my end of life is all taken care of and I do not have to burden my kids dealing with all the details.",
  },
  CA2: {
    reviewer: "Tracey F.",
    where: "Cypress, CA",
    blurb:
      "It was a quick and simple process and I feel better knowing that my loved ones will not have to do anything except make one phone call.",
  },
  CA3: {
    reviewer: "Fabie S.",
    where: "Van Nuys, CA",
    blurb:
      "They take care of everything. I'm with great peace of mind knowing that my family won't be stressing or struggling when the time comes.",
  },
  CA4: {
    reviewer: "Ricardo F.",
    where: "San Diego, CA",
    blurb:
      "Should have done this years ago, now my family won't have to worry about my arrangements anymore.",
  },
  CA6: {
    reviewer: "Lisa R.",
    where: "Pacheco, CA",
    blurb:
      "So thankful for having this option for my adult children. It's greatly appreciated.",
  },
  CO1: {
    reviewer: "Carrie A.",
    where: "Longmont, CO",
    blurb:
      "The process was simple and really nice to get this in place so my kids don't have to deal with these issues at my death.",
  },
  NV1: {
    reviewer: "Carol G.",
    where: "Las Vegas, NV",
    blurb:
      "I had all my questions answered and we are both so happy and relieved to have this done for our family.",
  },
  OR1: {
    reviewer: "Juanita P.",
    where: "Portland, OR",
    blurb:
      "The application process was done over the phone in just ten minutes. Signing the documents was simple with no technology issues.",
  },
  TX1: {
    reviewer: "James W.",
    where: "Weatherford, TX",
    blurb:
      "I was concerned about how hard this process would be and it was so much less complicated than I expected.",
  },
  TX2: {
    reviewer: "DeWayne R.",
    where: "Humble, TX",
    blurb:
      "The simplicity of the product and its options together with very competitive pricing made our prearrangements simple to understand and affordable.",
  },
  UT1: {
    reviewer: "Debbie L.",
    where: "Salt Lake City, UT",
    blurb:
      "I now have a plan that has my mind at rest and my family doesn't have to worry about paying for my funeral.",
  },
  WA1: {
    reviewer: "Susan D.",
    where: "Kent, WA",
    blurb:
      "This has helped me to take care of things that won't have to be handled by my children. All they have to do is make a phone call and everything is taken care of.",
  },
};

export function marketReview(marketSlug: string | null): MarketReview {
  if (marketSlug === null) return DEFAULT_REVIEW;
  return MARKET_REVIEWS[marketSlug] ?? DEFAULT_REVIEW;
}
